import { BuildTypeLogicService } from './../../../../logic/build-type/build-type-logic.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SaleDetailsEditDialogComponent } from '../sale-details-edit-dialog/sale-details-edit-dialog.component';
import { BaseDialogFormViewDirective } from '@app/shared/base-views/base-dialog-form-view.directive';
import { ToastService } from '@app/core/services/toast/toast.service';
import { COMPASS_DIRECTION_TYPE_ENUM, IBuildTypeDto } from '@classictechsolutions/hubapi-transpiled-enums';
import { IClientSaleLotUpdateDto, IClientSaleMappedItem } from '@app/logic/client-sale';
import {positiveIntegerPattern} from "@app/shared/utils/regex-patterns";
import { take } from 'rxjs';

interface IData {
    clientSale: IClientSaleMappedItem;
}

@Component({
    selector: 'cb-lot-details-edit-dialog',
    templateUrl: './lot-details-edit-dialog.component.html',
    styleUrls: ['./lot-details-edit-dialog.component.scss'],
    providers: [
        BuildTypeLogicService
    ],
    standalone: false
})
export class LotDetailsEditDialogComponent extends BaseDialogFormViewDirective<IClientSaleLotUpdateDto, any, any> implements OnInit {

    public clientSaleLotDetails: IClientSaleLotUpdateDto;

    public readonly COMPASS_DIRECTION_TYPE_ENUM = COMPASS_DIRECTION_TYPE_ENUM.toLookup();
    public buildTypes: IBuildTypeDto[] = [];

    constructor(
        public readonly dialogRef: MatDialogRef<SaleDetailsEditDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly data: IData,
        public readonly buildTypeLogic: BuildTypeLogicService,
        public toastService: ToastService
    ) {
        super(dialogRef, toastService);
    }

    public ngOnInit(): void {
        this.mapLotDetails();

        this.buildTypeLogic
            .getListByLotType(this.data.clientSale.lot.lotTypeId)
            .pipe(take(1)).subscribe(x => this.buildTypes = x);
    }

    public cancel(): void {
        this.dialogRef.close(false);
    }

    public save(): void {
        this.data.clientSale.updateLotDetails(this.clientSaleLotDetails)
            .pipe(take(1)).subscribe({
                next: this.handleNext,
                error: this.handleError
            });
    }

    private mapLotDetails(): void {
        this.clientSaleLotDetails = {
            lotNumber: this.data.clientSale.lot.lotNumber,
            buildTypeId: this.data.clientSale.lot.buildTypeId,
            isShowHome: this.data.clientSale.lot.isShowHome,
            hasTitle: this.data.clientSale.lot.hasTitle,
            expectedTitleDate: this.data.clientSale.lot.expectedTitleDate,
            roadDirectionId: this.data.clientSale.lot.roadDirectionId,
        };
    }

    protected readonly positiveIntegerPattern = positiveIntegerPattern;
}
